// import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, forwardRef, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import roundAccountTree from "@iconify/icons-ic/round-account-tree";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import RefreshIcon from "@mui/icons-material/Refresh";
import outlineImage from "@iconify/icons-ic/outline-image";
import CachedIcon from "@mui/icons-material/Cached";
import { v4 as uuidv4 } from "uuid";
import { Portal } from "@mui/base";
// material
import {
  Card,
  Table,
  Stack,
  Tooltip,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  IconButton,
  CircularProgress,
  Link,
} from "@mui/material";
// components
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import CloseIcon from "@mui/icons-material/Close";
import {
  LocationListHead,
  LocationListToolbar,
  LocationMoreMenu,
} from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
//
// import LOCATIONLIST from "../_mocks_/location";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { CallApi, BaseURL } from "../statics.js";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

const TABLE_HEAD = [
  { id: "title", label: "Title", alignRight: false },
  // { id: "priceType", label: "Price Type", alignRight: false },
  // { id: "dimensionType", label: "Dimension Type", alignRight: false },
  { id: "descr", label: "Description", alignRight: false },
  { id: "seoTag", label: "SEO Tag", alignRight: false },
  // { id: "createdAt", label: "Date & Time", alignRight: false },
  { id: "pic", label: "Picture", alignRight: false },
  { id: "priority", label: "Priority", alignRight: false },
  { id: "actions", label: "Product Steps", alignRight: false },
  { id: "" },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Products() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [currentLocItem, setCurrentLocItem] = useState({ title: "" });
  const [actionMode, setActionMode] = useState("accepting");
  const [dialogMode, setDialogMode] = useState("add");
  const [productTitle, setProductTitle] = useState("");
  const [productTitleErrorText, setProductTitleErrorText] = useState("");
  const [productDes, setProductDes] = useState("");
  const [productDesErrorText, setProductDesErrorText] = useState("");
  const [seoTag, setSeoTag] = useState("");
  const [priorityValue, setPriorityValue] = useState("");

  const [minHeight, setMinHeight] = useState("");
  const [minHeightErrorText, setMinHeightErrorText] = useState("");
  const [maxHeight, setMaxHeight] = useState("");
  const [maxHeightErrorText, setMaxHeightErrorText] = useState("");
  const [minWidth, setMinWidth] = useState("");
  const [minWidthErrorText, setMinWidthErrorText] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  const [maxWidthErrorText, setMaxWidthErrorText] = useState("");
  const [obsoletedValue, setObsoletedValue] = useState("");
  const [obsoletedValueErrorText, setObsoletedValueErrorText] = useState("");
  // const [addProductLoading, setAddProductLoading] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("priority");
  const [filterName, setFilterName] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [priceTypeList, setPriceTypeList] = useState([]);
  const [priceTypeValue, setPriceTypeValue] = useState("");
  const [priceTypeValueErrorText, setPriceTypeValueErrorText] = useState("");
  const [dimensionTypeList, setDimensionTypeList] = useState([]);
  const [dimensionTypeValue, setDimensionTypeValue] = useState("");
  const [dimensionTypeValueErrorText, setDimensionTypeValueErrorText] =
    useState("");
  const [config, setConfig] = useState(null);
  const [currentProductItem, setCurrentProductItem] = useState({
    id: "",
    title: "",
  });
  const [picDialogOpen, setPicDialogOpen] = useState(false);
  const [currentItemsPic, setCurrentItemsPic] = useState(null);
  const [uploadList, setUploadList] = useState([]);
  const [copyToDialog, setCopyToDialog] = useState(false);
  const [copyToPath, setCopyToPath] = useState([]);
  const [allLines, setAllLines] = useState([]);

  const navigate = useNavigate();

  // const productTitleTextField = useRef(null);

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    getAllLines1();
  }, []);

  useEffect(() => {
    if (tableData.length > 0) setDataLoading(false);
  }, [tableData]);

  const getAllLines1 = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: 0,
      count: 1000,
    };
    CallApi("getAllLines", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setAllLines(result.result);
          setCopyToPath([{ id: uuidv4(), list: result.result, value: "" }]);
          getAllLines();
        }
      } catch (error) {
        console.log("error: ", error);
        setDataLoading(false);
      }
    });
  };

  const getAllLines = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: page,
      count: rowsPerPage,
    };
    console.log(data);
    setDataLoading(true);
    CallApi("getAllLines", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setTableData(result.result);
          setTotalItems(result.paginateInfo.totalItems);
        }
        setDataLoading(false);
      } catch (error) {
        console.log("error: ", error);
        setDataLoading(false);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (tableData.length > 0) getAllLines();
  }, [page]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // const handleFilterByName = (event) => {
  //   setFilterName(event.target.value);
  // };

  // useEffect(() => {
  //   if (addDialogOpen) productTitleTextField.current.focus();
  // }, [addDialogOpen]);

  const handleClickOpen = () => {
    setDialogMode("add");
    setProductTitle("");
    setProductDes("");
    setSeoTag("");
    setProductTitleErrorText("");
    setPriorityValue("");
    setUploadList([]);
    setAddDialogOpen(true);
  };

  const addProduct = () => {
    if (!productTitle) {
      setProductTitleErrorText("Product title cannot be empty");
      return;
    } else {
      setProductTitleErrorText("");
    }

    if (dialogMode !== "update" && uploadList.length < 1) {
      setSnackType("error");
      setSnackbarMessage("Please upload a picture");
      setSnackbarOpen(true);
      return;
    }

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      title: productTitle ? productTitle : "",
      descr: productDes ? productDes : "",
      seoTag1: seoTag ? seoTag : "",
      priority: priorityValue,
      // pic:
      //   uploadList.length > 0
      //     ? uploadList[0].fileName
      //     : dialogMode === "update"
      //     ? currentProductItem.pic
      //     : "",
    };
    // if (uploadList.length>0) data.pic=uploadList[0].fileName
    let apiname = "createNewLine";

    if (dialogMode === "update") {
      data = {
        username: getCookie("username"),
        token: getCookie("token"),
        lineId: currentProductItem._id,
        title: productTitle ? productTitle : "",
        descr: productDes ? productDes : "",
        seoTag1: seoTag ? seoTag : "",
        priority: priorityValue,
        // pic: uploadList[0].fileName,
      };

      apiname = "updateLine";
    }

    data.pic =
      uploadList.length > 0
        ? uploadList[0].fileName
        : dialogMode === "update"
        ? currentProductItem.pic
        : "";
    // if (uploadList.length > 0) data.pic = uploadList[0].fileName;

    console.log(data);
    setButtonDisabled(true);

    CallApi(apiname, "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            getAllLines();
            setSnackType("success");

            if (apiname === "createNewLine")
              setSnackbarMessage(
                "'" + productTitle + "' has been added successfully"
              );
            else
              setSnackbarMessage(
                "'" + productTitle + "' has been updated successfully"
              );

            setSnackbarOpen(true);
            setAddDialogOpen(false);
          } else {
            setSnackType("error");
            setSnackbarMessage(result.message);
            setSnackbarOpen(true);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const onEditItem = (item) => {
    if (!buttonDisabled) {
      console.log(item);
      setCurrentProductItem(item);
      setDialogMode("update");
      setProductTitle(item.title);
      setProductDes(item.descr);
      setSeoTag(item.seoTag1 ? item.seoTag1 : "");
      setPriorityValue(
        item.priority || item.priority === 0 ? item.priority : ""
      );
      setProductTitleErrorText("");
      setUploadList([]);
      setAddDialogOpen(true);
    }
  };

  const onDeleteItem = (item) => {
    if (!buttonDisabled) {
      setCurrentProductItem(item);
      setDeleteDialogOpen(true);
    }
  };

  const onCopyToItem = (item) => {
    if (!buttonDisabled) {
      setCopyToPath([{ id: uuidv4(), list: allLines, value: "" }]);
      setCurrentProductItem(item);
      setCopyToDialog(true);
    }
  };

  const handleChangePriceType = (event) => {
    const {
      target: { value },
    } = event;
    setPriceTypeValue(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeDimensionType = (event) => {
    const {
      target: { value },
    } = event;
    setDimensionTypeValue(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeObsoleted = (event) => {
    const {
      target: { value },
    } = event;
    setObsoletedValue(typeof value === "string" ? value.split(",") : value);
  };

  const confirmDeleteItem = () => {
    setDeleteDialogOpen(false);

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      lineId: currentProductItem._id,
    };

    console.log(data);

    setButtonDisabled(true);
    CallApi("removeLine", "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            getAllLines();
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const onSelectFileComplete = (event) => {
    let files = [];
    console.log(event);
    for (let i = 0; i < event.target.files.length; i++) {
      // console.log(event.target.files[i]);
      if (
        !event.target.files[i] ||
        (event.target.files[i].type !== "image/jpg" &&
          event.target.files[i].type !== "image/png" &&
          event.target.files[i].type !== "image/webp" &&
          event.target.files[i].type !== "image/jpeg")
      ) {
        setSnackType("error");
        setSnackbarMessage("some files not valid for uploading");
        setSnackbarOpen(true);
        return;
      } else {
        files.push({ file: event.target.files[i], status: "loading" });
      }
    }

    setUploadList(files);
    document.getElementById("selectPicDialog").value = "";
  };

  useEffect(() => {
    if (uploadList.length > 0) {
      let found = false;
      uploadList.forEach((element) => {
        if (!found && element.status === "loading") {
          found = true;
          uploadFile(element.file);
        }
      });
    }
  }, [uploadList]);

  const uploadFile = (file) => {
    const data = new FormData();
    data.append("picture", file);
    data.append("username", getCookie("username"));
    data.append("token", getCookie("token"));

    console.log(file);

    CallApi("uploadPicture", "post", data, true)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            const newState = uploadList.map((obj) => {
              if (obj.file === file) {
                return { ...obj, status: "ok", fileName: result.fileName };
              }
              return obj;
            });

            setUploadList(newState);
          } else {
            const newState = uploadList.map((obj) => {
              if (obj.file === file) {
                return { ...obj, status: "failed" };
              }
              return obj;
            });

            setUploadList(newState);
          }
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        const newState = uploadList.map((obj) => {
          if (obj.file === file) {
            return { ...obj, status: "failed" };
          }
          return obj;
        });

        setUploadList(newState);
      });
  };

  const onResultClick = (item) => {
    setCurrentItemsPic(item.pic);
    setPicDialogOpen(true);
  };

  const loadSubCat = () => {
    findLineStepwithPath();
  };

  const findLineStepwithPath = () => {
    let parents = [];

    copyToPath.forEach((element) => {
      parents.push(element.value);
    });

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      lineId: parents[parents.length - 1],
      parentList: parents,
      page: 0,
      count: 1000,
    };
    console.log(data);
    setButtonDisabled(true);
    CallApi("findLineStepwithPath", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          if (result.result.length > 0) {
            let path = JSON.parse(JSON.stringify(copyToPath));
            path.push({ id: uuidv4(), list: result.result, value: "" });
            setCopyToPath(path);
          } else {
            setSnackType("error");
            setSnackbarMessage("there is no product steps");
            setSnackbarOpen(true);
          }
        }
        setButtonDisabled(false);
      } catch (error) {
        console.log("error: ", error);
        setButtonDisabled(false);
      }
    });
  };

  const confirmCopy = () => {
    let i = 0;
    let index = -1;
    let destinationLineStepPath = [];
    copyToPath.forEach((element) => {
      if (!element.value && index === -1) index = i;
      destinationLineStepPath.push(element.value);
      i++;
    });

    if (index > -1) {
      if (index === 0) {
        setSnackType("error");
        setSnackbarMessage("please select destination product");
        setSnackbarOpen(true);
      } else {
        setSnackType("error");
        setSnackbarMessage("please select product step " + index);
        setSnackbarOpen(true);
      }

      return;
    }

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      originLineId: currentProductItem._id,
      destinationLineId: copyToPath[0].value,
      originLineStepPath: "," + currentProductItem._id + ",",
      destinationLineStepPath: "," + destinationLineStepPath.toString() + ",",
    };

    console.log(data);
    // return;
    setButtonDisabled(true);
    CallApi("copyLineSteps", "post", data)
      .then((result) => {
        setButtonDisabled(false);
        try {
          console.log(result);
          // if (result.status === 200) {
          //   getAllLines();
          // }

          // setCopyToDialog(false);

          setSnackType("success");
          setSnackbarMessage("product successfully copied");
          setSnackbarOpen(true);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  return (
    <Page title="Products | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Products
            </Typography>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              // component={RouterLink}
              // to="new"
              // state={{ type: "new" }}
              disabled={buttonDisabled}
              startIcon={<Icon icon={plusFill} />}
            >
              New Product
            </Button>
          </Stack>

          <Card>
            {/* <LocationListToolbar
              filterName={filterName}
              searchPlaceHolder="Search title..."
              onFilterName={handleFilterByName}
            /> */}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        const { _id, title, descr, createdAt, pic, seoTag1 } =
                          row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="normal"
                            >
                              <Typography variant="subtitle2" noWrap>
                                {title}
                              </Typography>
                            </TableCell>
                            <TableCell>{descr ? descr : "-"}</TableCell>
                            <TableCell>{seoTag1 ? seoTag1 : "-"}</TableCell>
                            <TableCell align="left">
                              {pic && (
                                <IconButton
                                  aria-label="result"
                                  onClick={() => {
                                    onResultClick(row);
                                  }}
                                >
                                  <Icon icon={outlineImage} fontSize={22} />
                                </IconButton>
                              )}
                            </TableCell>
                            <TableCell>
                              {row.priority || row.priority === 0
                                ? row.priority
                                : "-"}
                            </TableCell>
                            <TableCell align="left">
                              <Link href={"/products/" + _id}>
                                <Box
                                  component={Icon}
                                  icon={roundAccountTree}
                                  sx={{
                                    color: "primary.main",
                                    width: 24,
                                    height: 24,
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>
                              {/* <Stack
                                  direction="row"
                                  spacing={0.5}
                                  divider={
                                    <Divider orientation="vertical" flexItem />
                                  }
                                  alignItems="center"
                                >
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    href={"/products/" + _id}
                                  >
                                    Step
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    href={"/models?productId=" + _id}
                                  >
                                    Model
                                  </Button>
                                </Stack> */}
                            </TableCell>
                            <TableCell align="right">
                              <LocationMoreMenu
                                onEdit={() => onEditItem(row)}
                                onDelete={() => onDeleteItem(row)}
                                onCopyTo={() => onCopyToItem(row)}
                                hasCopyTo
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}
      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={deleteDialogOpen}
        TransitionComponent={Transition}
        // keepMounted
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Deleting Product</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <DialogContentText id="alert-dialog-description">
            {"Are you sure for deleting '" + currentProductItem.title + "'?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDeleteItem}>Yes</Button>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={picDialogOpen}
        TransitionComponent={Transition}
        onClose={() => {
          setPicDialogOpen(false);
        }}
      >
        <DialogContent>
          <img alt="" src={BaseURL + currentItemsPic} />
        </DialogContent>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={addDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setAddDialogOpen(false);
        }}
      >
        <DialogTitle>
          {dialogMode === "add" ? "Add New Product" : "Edit Product"}
        </DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          {/* <Stack direction="row" spacing={1} style={{ alignItems: "center" }}>
            <div
              style={{
                height: "1px",
                backgroundColor: "var(--mainColor)",
                flex: "1",
              }}
            />
            <div>or</div>
            <div
              style={{
                height: "1px",
                backgroundColor: "var(--mainColor)",
                flex: "1",
              }}
            />
          </Stack> */}

          <TextField
            fullWidth
            sx={{ mb: 2, mt: 2 }}
            autoFocus
            type="text"
            label="Title"
            value={productTitle}
            // inputRef={productTitleTextField}
            onChange={(e) => setProductTitle(e.target.value)}
            disabled={buttonDisabled}
            // disabled={addProductLoading}
            helperText={productTitleErrorText}
            error={productTitleErrorText ? true : false}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Description"
            value={productDes}
            onChange={(e) => setProductDes(e.target.value)}
            disabled={buttonDisabled}
            helperText={productDesErrorText}
            error={productDesErrorText ? true : false}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="SEO Tag"
            value={seoTag}
            onChange={(e) => setSeoTag(e.target.value)}
            disabled={buttonDisabled}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Priority"
            value={priorityValue}
            onChange={(e) => setPriorityValue(e.target.value)}
            disabled={buttonDisabled}
          />

          <Button
            fullWidth
            sx={{ mb: 1 }}
            // onClick={() => setDialogOpen(false)}
            variant="outlined"
            disabled={buttonDisabled}
            startIcon={<CloudUploadIcon />}
            component="label"
          >
            Upload Picture
            <input
              hidden
              accept="image/png,.jpg,.webp"
              // multiple
              type="file"
              onChange={onSelectFileComplete}
              id="selectPicDialog"
            />
          </Button>

          <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
            {uploadList.map((item, i) => {
              return (
                <Chip
                  disabled={buttonDisabled}
                  key={i}
                  sx={{ mb: 0.5, mr: 0.5 }}
                  icon={
                    item.status === "ok" ? (
                      <CheckIcon />
                    ) : item.status === "failed" ? (
                      <Tooltip title="Retry">
                        <IconButton
                          aria-label="retry"
                          size="small"
                          onClick={() => {
                            const newState = uploadList.map((obj) => {
                              if (obj.file === item.file) {
                                return { ...obj, status: "loading" };
                              }
                              return obj;
                            });

                            setUploadList(newState);
                          }}
                        >
                          <RefreshIcon sx={{ fontSize: "18px" }} />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <CircularProgress color="secondary" size={20} />
                    )
                  }
                  label={item.file.name}
                  variant="outlined"
                  color={
                    item.status === "ok"
                      ? "primary"
                      : item.status === "ok"
                      ? "error"
                      : "secondary"
                  }
                  onDelete={
                    item.status === "ok"
                      ? () => {
                          setUploadList((chips) =>
                            chips.filter((chip) => chip.file !== item.file)
                          );
                        }
                      : undefined
                  }
                />
              );
            })}
          </Box>

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={addProduct}
            variant="contained"
            disabled={buttonDisabled}
          >
            {dialogMode === "add" ? "Add" : "Update"}
          </Button>
          <Button
            onClick={() => setAddDialogOpen(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={copyToDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setCopyToDialog(false);
        }}
      >
        <DialogTitle>Specify the destination path</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          {copyToPath.map((item, i) => {
            return (
              <FormControl
                key={item.id}
                sx={{ mb: 2, mt: 1 }}
                fullWidth
                disabled={buttonDisabled}
                // error={productValueErrorText ? true : false}
              >
                <InputLabel>
                  {i < 1 ? "Product" : "Product Step " + i}
                </InputLabel>
                <Select
                  value={item.value ? item.value : ""}
                  onChange={(e) => {
                    let path = JSON.parse(JSON.stringify(copyToPath));
                    let index = 0;
                    let counter = 0;
                    path.forEach((element) => {
                      if (element.id === item.id) {
                        element.value = e.target.value;
                        index = counter;
                      }
                      counter++;
                    });

                    if (path.length - 1 > index) path.splice(index + 1);

                    setCopyToPath(path);
                  }}
                  input={
                    <OutlinedInput
                      label={i < 1 ? "Product" : "Product Step " + i}
                    />
                  }
                  MenuProps={MenuProps}
                >
                  {item.list.map((pt) => (
                    <MenuItem key={pt._id} value={pt._id}>
                      {i === 0 ? pt.title : pt.stepItemTitle}
                    </MenuItem>
                  ))}
                </Select>
                {/* <FormHelperText>{productValueErrorText}</FormHelperText> */}
              </FormControl>
            );
          })}
          {copyToPath[copyToPath.length - 1]?.value && (
            <Button
              fullWidth
              sx={{ mb: 1 }}
              onClick={loadSubCat}
              variant="outlined"
              disabled={buttonDisabled}
              startIcon={<CachedIcon />}
              component="label"
            >
              Load Product Steps
            </Button>
          )}

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={confirmCopy}
            variant="contained"
            disabled={buttonDisabled}
          >
            Copy
          </Button>
          <Button
            onClick={() => setCopyToDialog(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
